import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import { Wrapper, Card, ErrorCode, Message, Description, BackBtn } from './NotFound.styles';

export default function NotFound() {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);

  return (
    <Wrapper>
      <Card>
        <ErrorCode accent={theme.accent}>404</ErrorCode>
        <Message>Página No Encontrada</Message>
        <Description>
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </Description>
        <BackBtn accent={theme.accent} onClick={() => navigate('/')}>
          Volver al Inicio
        </BackBtn>
      </Card>
    </Wrapper>
  );
}
